var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-reporte-ejecutivo"}},[(_vm.tipo === 1)?[_c('card',{attrs:{"listado":_vm.listado,"imprimir":_vm.imprimir}})]:[_c('listado',{attrs:{"listado":_vm.listado,"imprimir":_vm.imprimir}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }